import { HttpErrorResponse } from '@angular/common/http';

/**
 * Bir hatanın geçici (anlık teknik) mi kalıcı (business) mı olduğunu belirler.
 *
 * SSR tarafında bu ayrım SEO açısından kritiktir: geçici hatalarda 503
 * dönülmeli (URL index'te kalır, Google sonra tekrar dener), kalıcı hatalarda
 * ise 301/404 dönülebilir.
 *
 * - HTTP 5xx: sunucu tarafı anlık hata → geçici.
 * - HTTP 0: network hatası / timeout / DNS / CORS → geçici.
 * - HTTP 4xx: kaynağın gerçekten bulunmadığını/geçersiz olduğunu gösterir → kalıcı.
 * - HttpErrorResponse olmayan hatalar (ör. render/parse hataları): teknik kabul
 *   edilip geçici sayılır, çünkü yanlışlıkla 301 dönmenin SEO maliyeti geri
 *   döndürülemez.
 */
export function isTransientHttpError(err: unknown): boolean {
  if (!(err instanceof HttpErrorResponse)) {
    return true;
  }

  return err.status === 0 || err.status >= 500;
}
